// Modules
import { SAVE_PLAYER_SIZE } from './types';

export const playerInternalSavePlayerSizesAction = (payload) => ({
  type: SAVE_PLAYER_SIZE,
  payload,
});
